webpackJsonp([75499332218354],{

/***/ 345:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _gatsbyLink = __webpack_require__(3);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _Anatomy = __webpack_require__(10);
	
	var _Anatomy2 = _interopRequireDefault(_Anatomy);
	
	var _Markdown = __webpack_require__(5);
	
	var _Markdown2 = _interopRequireDefault(_Markdown);
	
	var _CodeTabs = __webpack_require__(7);
	
	var _CodeTabs2 = _interopRequireDefault(_CodeTabs);
	
	var _CodeTab = __webpack_require__(6);
	
	var _CodeTab2 = _interopRequireDefault(_CodeTab);
	
	var _QuickstartBranch = __webpack_require__(8);
	
	var _QuickstartBranch2 = _interopRequireDefault(_QuickstartBranch);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	exports.default = function (props) {
	  return _react2.default.createElement(
	    _Anatomy2.default,
	    null,
	    _react2.default.createElement(
	      'h1',
	      null,
	      'config/reducers.js'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'This file is connected to the ',
	      _react2.default.createElement(
	        'code',
	        null,
	        'lore-hook-reducers'
	      ),
	      ' hook and overrides the default reducer behaviors.'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'You can learn more about the configuration options ',
	      _react2.default.createElement(
	        _gatsbyLink2.default,
	        { to: '/hooks/lore-hook-reducers/' },
	        'here'
	      ),
	      '.'
	    ),
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Default Config'
	    ),
	    _react2.default.createElement(
	      'p',
	      null,
	      'The default config is shown below.'
	    ),
	    _react2.default.createElement(_Markdown2.default, { text: '\n      /**\n       * Configuration file for reducers\n       *\n       * This file is where you define overrides for the default reducer behaviors.\n       */\n\n      export default {\n\n        /**\n         * Specify dependencies between child reducers, which will determine the\n         * order they are called in, as well as what data is passed in through the\n         * third \'options\' argument:\n         *\n         * function someReducer(state, action, options) {\n         *   // your reducer code...\n         * }\n         *\n         * The `options.nextState` property will contain the results of the child\n         * reducers you have declared a dependency on.\n         *\n         * The default dependency structure (based on the built-in blueprints) looks\n         * like this:\n         */\n\n        // dependencies: {\n        //   modelName: {\n        //     byId: [],\n        //     byCid: [],\n        //     find: [\'byId\', \'byCid\']\n        //   }\n        // }\n\n        /**\n         * Change what gets returned from the Redux store.\n         *\n         * This method is intended ONLY as a way to explore different solutions for addressing\n         * immutability concerns that arise when components have a direct reference to\n         * the data kept in the reducers.\n         *\n         * The default behavior in Redux is to provide components with a reference to the\n         * store state returned from the reducers. This poses a problem when a component\n         * tries to change that data, because it will modify the state of the store through\n         * that reference.\n         *\n         * To address this issue, the top-level reducer will invoke this method right before\n         * returning the next state, which gives you the ability to experiment with different\n         * solutions for this problem.\n         *\n         * The default behavior is to return a copy of the store state, which will prevent any\n         * component from being able to modify the "truth" kept in the reducers.\n         *\n         * Others solutions could be invoking `Object.freeze(nextState)` (which will throw an\n         * error if a component tries to modify the store state) or converting the store state\n         * to an Immutable object using `Immutable.map(nextState)` from Immutable.js.\n         */\n\n        // nextState: function(nextState) {\n        //   return _.cloneDeep(nextState);\n        // }\n\n      }\n      ' })
	  );
	};
	
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-anatomy-config-reducers-js-662f6360a11b88753816.js